(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/numberlist.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/numberlist.js');


'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class NumberList extends Array {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    _.extend(this, svs.numbergames.game_model.utils.numberlist_events());
    this.minValue = 1;
    this.maxValue = props.maxValue;
    this.minLength = props.minLength || 1;
    this.maxLength = props.maxLength;
    this.huxfluxManual = props.huxfluxManual;
    this.skipSort = props.skipSort || false;
    if (props && props.numbers) {
      props.numbers.forEach(num => {
        this.add({
          number: Number(num.number || num),
          manual: Boolean(num.manual)
        });
      });
    }
  }
  toggle(_ref) {
    let number = _ref.number,
      manual = _ref.manual;
    if (this.canAdd(number)) return this.add({
      number,
      manual
    });
    if (this.contains(number)) return this.remove({
      number
    });
  }
  add(_ref2) {
    let number = _ref2.number,
      manual = _ref2.manual,
      _ref2$silent = _ref2.silent,
      silent = _ref2$silent === void 0 ? false : _ref2$silent;
    if (this.canAdd(number)) {
      this.push({
        number,
        manual
      });
      if (!this.skipSort) {
        this.sort();
      }
      const index = this.indexOf(number);
      if (!silent) this.trigger('number:added', {
        number,
        index
      });
      return {
        number,
        index
      };
    }
  }
  addRandom() {
    let i = 1,
      randNum;
    while (i--) {
      randNum = svsRandom.getRandomInt(this.minValue, this.maxValue);
      if (this.contains(randNum)) {
        i++;
      } else {
        this.add({
          number: randNum,
          manual: false
        });
      }
    }
  }
  addHuxfluxed(_ref3) {
    let number = _ref3.number,
      manual = _ref3.manual;
    if (this.canAdd(number)) {
      this.push({
        number,
        manual
      });
      this.sort();
      const index = this.indexOf(number);
      this.trigger('huxflux:added', {
        number,
        index
      });
      return {
        number,
        index
      };
    }
  }
  prepareHuxflux(size) {
    if (size) this.maxLength = size;
    let i = this.length;
    while (i--) {
      const numObj = this[i];
      if (numObj && (!numObj.manual || this.huxfluxManual)) {
        this.splice(i, 1);
        this.trigger('huxflux:removed', _objectSpread(_objectSpread({}, numObj), {}, {
          index: i
        }));
      }
    }
    return this.getRandomNumbers();
  }
  getRandomNumbers() {
    const manualNumbers = this.huxfluxManual ? [] : this.getManualNumbers();
    const huxfluxLength = this.maxLength - manualNumbers.length;
    const huxfluxed = [];
    while (huxfluxed.length < huxfluxLength) {
      const number = svsRandom.getRandomInt(this.minValue, this.maxValue);
      if (manualNumbers.indexOf(number) === -1 && huxfluxed.indexOf(number) === -1) {
        huxfluxed.push(number);
      }
    }
    huxfluxed.sort((a, b) => a - b);
    return huxfluxed;
  }
  fill() {
    let i = this.maxLength - this.length;
    while (i--) {
      this.addRandom();
    }
  }
  randomize() {
    let i = this.length,
      randNum;
    while (i--) {
      randNum = svsRandom.getRandomInt(this.minValue, this.maxValue);
      if (this.contains(randNum)) {
        i++;
      } else {
        this.set({
          index: i,
          number: randNum,
          manual: false
        });
      }
    }
  }
  huxflux() {
    let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.maxLength;
    let randNum,
      i = 0;
    if (this.huxfluxManual) {
      this.splice(0, this.length);
    }
    while (i < length) {
      if (this[i] && this[i].manual) {
        i++;
      } else {
        randNum = svsRandom.getRandomInt(this.minValue, this.maxValue);
        if (!this.contains(randNum)) {
          if (!this[i]) {
            this.addHuxfluxed({
              number: randNum,
              manual: false,
              silent: true
            });
          } else {
            this.set({
              index: i,
              number: randNum,
              manual: false
            });
          }
          i++;
        }
      }
    }
  }
  set(_ref4) {
    let index = _ref4.index,
      number = _ref4.number,
      manual = _ref4.manual;
    if (this.canSet({
      number,
      index
    })) {
      this[index] = {
        number,
        manual
      };
      this.trigger('number:changed', {
        number,
        index
      });
      return {
        number,
        index
      };
    }
  }
  canSet(_ref5) {
    let number = _ref5.number,
      index = _ref5.index;
    const isValidIndex = index < this.length;
    const isChange = this[index] && this[index].number !== number;
    return isValidIndex && !this.contains(number) && isChange;
  }
  toArray() {
    return Array.from(this.map(_ref6 => {
      let number = _ref6.number;
      return number;
    }));
  }
  toOwnRowsString() {
    return this.toArray().reduce((rowString, n) => "".concat(rowString).concat(n.toString().length === 1 ? '0' : '').concat(n), '');
  }
  getManualNumbers() {
    return this.filter(numObj => numObj && numObj.manual);
  }
  getManualNumbersLength() {
    return this.getManualNumbers().length;
  }
  get(num) {
    let result = null;
    this.forEach(numObj => {
      if (numObj && numObj.number === num) {
        result = numObj;
      }
    });
    return result;
  }
  sort() {
    Array.prototype.sort.call(this, (a, b) => a.number - b.number);
  }
  remove(_ref7) {
    let number = _ref7.number;
    const index = this.indexOf(number);
    if (index > -1) {
      this.splice(index, 1);
      this.trigger('number:removed', {
        number,
        index
      });
      return {
        number,
        index
      };
    }
  }
  removeAll() {
    const numbers = this.toArray();
    this.splice(0, this.length);
    if (numbers.length) this.trigger('numbers:removed:all', {
      numbers
    });
    return numbers;
  }
  contains(num) {
    return this.indexOf(num) > -1;
  }
  getQuickpickState() {
    const _svs$numbergames$game = svs.numbergames.game_model.constants.quickpickStates,
      ALL_HUXFLUXED = _svs$numbergames$game.ALL_HUXFLUXED,
      PARTIAL_HUXFLUXED = _svs$numbergames$game.PARTIAL_HUXFLUXED,
      NOT_HUXFLUXED = _svs$numbergames$game.NOT_HUXFLUXED;
    let quickpickState = null;
    this.forEach(numObj => {
      if (!quickpickState) {
        quickpickState = numObj.manual ? NOT_HUXFLUXED : ALL_HUXFLUXED;
      } else if (quickpickState === NOT_HUXFLUXED && !numObj.manual || quickpickState === ALL_HUXFLUXED && numObj.manual) {
        quickpickState = PARTIAL_HUXFLUXED;
      }
    });
    return quickpickState;
  }
  remaining() {
    return this.maxLength - this.length;
  }
  setMaxLength(maxLength) {
    this.maxLength = maxLength;
  }
  setLengths(_ref8) {
    let min = _ref8.min,
      max = _ref8.max;
    if (typeof min === 'number') this.minLength = min;
    if (typeof max === 'number') this.maxLength = max;
  }
  indexOf(number) {
    return this.findIndex(num => num && num.number === number);
  }
  findIndex(callback) {
    return _.findIndex(this, callback);
  }
  canAdd(number) {
    return !this.isFull() && !this.contains(number);
  }
  isEmpty() {
    return this.length === 0;
  }
  isFull() {
    return this.length >= this.maxLength;
  }
  isValid() {
    return this.every(_ref9 => {
      let number = _ref9.number;
      return number >= this.minValue && number <= this.maxValue;
    }) && Boolean(this.length) && this.length >= this.minLength && this.length <= this.maxLength;
  }
  canHuxflux() {
    return this.getManualNumbersLength() < this.maxLength || this.huxfluxManual;
  }
}
svs.numbergames.game_model.utils.NumberList = NumberList;

 })(window);